import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import EasyTooltip from 'components/EasyTooltip';
import Flex from 'components/Flex';
import Icon from 'components/Icon';
import Tab from 'components/Tab';
import VisuallyHidden from 'components/VisuallyHidden';
function AdminShortcuts(_ref) {
  var isAdmin = _ref.isAdmin,
    myTeamsLink = _ref.myTeamsLink;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Flex, {
    align: "stretch",
    gap: "xxxs",
    mr: "-xs"
  }, myTeamsLink && /*#__PURE__*/React.createElement(EasyTooltip, {
    content: t('navbar_my_teams'),
    placement: "bottom"
  }, /*#__PURE__*/React.createElement(Tab, {
    as: NavLink,
    to: myTeamsLink,
    activeClassName: "is-active"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "team",
    mx: "xxs"
  }), /*#__PURE__*/React.createElement(VisuallyHidden, null, t('navbar_my_teams')))), isAdmin && /*#__PURE__*/React.createElement(EasyTooltip, {
    content: t('navbar_admin'),
    placement: "bottom"
  }, /*#__PURE__*/React.createElement(Tab, {
    as: "a",
    href: "/admin"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "settings",
    mx: "xxs"
  }), /*#__PURE__*/React.createElement(VisuallyHidden, null, t('navbar_admin')))));
}
export default AdminShortcuts;